(function () {
  const renderBlocker = document.getElementById('view-transition-render-blocker');

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || isLowPowerDevice()) {
    renderBlocker?.remove();
    return;
  }

  // Safety timeout — ensure FCP under 1.8s even if main content is slow
  const timeout = Math.max(0, 1800 - performance.now());
  setTimeout(() => renderBlocker?.remove(), timeout);

  window.addEventListener('pageswap', (event) => {
    const { viewTransition } = event;
    if (!viewTransition || isLowPowerDevice()) {
      viewTransition?.skipTransition();
      return;
    }

    // Cancel on user interaction for better INP
    for (const name of ['pointerdown', 'keydown']) {
      document.addEventListener(name, () => viewTransition.skipTransition(), { once: true });
    }

    // Check if a product card triggered a custom transition
    document
      .querySelectorAll('[data-view-transition-type]:not([data-view-transition-triggered])')
      .forEach((el) => el.removeAttribute('data-view-transition-type'));

    const triggered = document.querySelector('[data-view-transition-triggered]');
    const type = triggered?.getAttribute('data-view-transition-type');

    viewTransition.types.clear();

    if (type) {
      viewTransition.types.add(type);
      sessionStorage.setItem('scale-transition-type', type);
    } else {
      viewTransition.types.add('page-navigation');
      sessionStorage.removeItem('scale-transition-type');
    }
  });

  window.addEventListener('pagereveal', async (event) => {
    const { viewTransition } = event;
    if (!viewTransition || isLowPowerDevice()) {
      viewTransition?.skipTransition();
      return;
    }

    const customType = sessionStorage.getItem('scale-transition-type');

    viewTransition.types.clear();

    if (customType) {
      viewTransition.types.add(customType);

      await viewTransition.finished;

      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');

      const idle = typeof requestIdleCallback === 'function' ? requestIdleCallback : setTimeout;
      idle(() => {
        sessionStorage.removeItem('scale-transition-type');
        document.querySelectorAll('[data-view-transition-type]').forEach((el) => {
          el.removeAttribute('data-view-transition-type');
        });
      });
    } else {
      viewTransition.types.add('page-navigation');
    }
  });

  function isLowPowerDevice() {
    return Number(navigator.hardwareConcurrency) <= 2 || Number(navigator.deviceMemory) <= 2;
  }
})();
